import { create } from 'zustand';

interface DoBoxKeyboardFocusState {
  focusedEntryId: string | null;
}

interface DoBoxKeyboardFocusActions {
  setFocusedEntryId: (id: string | null) => void;
}

type DoBoxKeyboardFocusStore = DoBoxKeyboardFocusState &
  DoBoxKeyboardFocusActions;

// Board cards are memo'd; passing the focused id as a prop would re-render
// every card on each keystroke. Cards subscribe to this store instead, so
// only the previously-focused and newly-focused card re-render.
export const useDoBoxKeyboardFocusStore = create<DoBoxKeyboardFocusStore>(
  (set) => ({
    focusedEntryId: null,

    setFocusedEntryId: (id: string | null) => {
      set({ focusedEntryId: id });
    },
  }),
);
